<nav class="navbar navbar-main flex-row justify-content-between">
    <span>Socialboards <strong translate>Analytics & Reporting</strong></span>
    <div>
        <strong translate>Basic</strong>
        <a
            target="_blank"
            [href]="
                commonDataService.language === 'nb'
                    ? 'https://form.socialboards.no/socialboards?categoryid=10285'
                    : 'https://form.socialboards.com/socialboards/en?categoryid=10291'
            "
            style="margin-left: 20px"
            translate
            >Order full version</a
        >
    </div>
    <div>
        <a [href]="'https://www.zisson.com/contact-us/'" target="_blank" translate>Help & Feedback</a>
    </div>
    <div>
        <sb-settings-menu
            [user]="commonDataService.user"
            [customerSettings]="commonDataService.customerSettings"
            [communityName]="commonDataService.community"
            [language]="commonDataService.language"
            (logout)="authenticationService.logOff({ isNeedToRevokeToken: true })">
        </sb-settings-menu>
    </div>
</nav>
<div class="reports-content">
    @if (dashboardUrl) {
        <iframe id="embed" style="display: block; height: 100%; width: 100%; border: 0" [src]="dashboardUrlSanitized">
        </iframe>
    }
</div>
